import { useLanguage, languageNames } from "@/hooks/use-language";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { GlobeIcon, Check } from "lucide-react";
import { getTranslation } from "@/lib/translations";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 rounded-full">
          <GlobeIcon className="h-4 w-4" />
          <span className="sr-only">{getTranslation("changeLanguage", language)}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {(Object.keys(languageNames) as Array<keyof typeof languageNames>).map((lang) => (
          <DropdownMenuItem
            key={lang}
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setLanguage(lang)}
          >
            <span>{languageNames[lang]}</span>
            {language === lang && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}